import { render, staticRenderFns } from "./HRApprove.vue?vue&type=template&id=774f4767&scoped=true"
import script from "./HRApprove.vue?vue&type=script&lang=js"
export * from "./HRApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774f4767",
  null
  
)

export default component.exports